import { axiosInstance as axios } from "services";

export const applyPriceChange = async (changeId, companyId) => {
  const { data } = await axios.post(
    `/admin/subscription/global-price-change/${changeId}/apply`,
    { companyId }
  );
  if (!data.success) throw new Error(data.error?.message || "Failed to apply price change");
  return data;
};

